import {request} from '@/helpers/apiClient'
import {TIER_CONFIG} from '@/utils/constants/apiConfig/tierConfig'

export const TIER_QUERY_KEY = {
  ACTIVE_TIERS: 'active-tiers',
  TIER_OPTIONS: 'tier-options',
}
export const getTierStores = async (tierID, queryParams) => request(TIER_CONFIG.TIER_STORES(tierID, queryParams))
export const fetchTiers = async queryParams => request(TIER_CONFIG.TIERS, {}, queryParams)
export const getTierOptions = async () => request(TIER_CONFIG.CREATE_TIER_OPTIONS)
export const createTier = async (tierData, isDraft = false) => {
  const status = isDraft ? 'DRAFT' : 'PUBLISHED'
  const payload = {
    ...tierData,
    status
  }

  return request(TIER_CONFIG.CREATE_UPDATE_TIER, { data: payload })
}
export const postMoveStores = async (tierID, requestBody) => request(TIER_CONFIG.MOVE_STORES(tierID), requestBody)
